/**
 * Entry point, loaded on every page: modals, drawers and the header.
 * Every other script is imported by the section, block or snippet that renders its markup and carries
 * its name: section-*.js, snippet-*.js, block-*.js; theme-*.js is shared. The import map in
 * layout/theme.liquid maps every file to `@theme/<name>`. Modules bind their elements with onSection()
 * from theme-utils, which also covers sections the theme editor re-renders.
 */
import '@theme/theme-modal';
import '@theme/section-header';
import { runModuleScripts } from '@theme/theme-utils';
import { syncShopScore } from '@theme/theme-shop-score';

// Theme editor: a section added or re-rendered in the editor brings its own module scripts
document.addEventListener('shopify:section:load', (e) => {
  runModuleScripts(e.target);
  syncShopScore();
});

// Live shop score in header, hero and footer, after the page has settled
(window.requestIdleCallback || ((cb) => setTimeout(cb, 1500)))(() => syncShopScore());
